import React, { useCallback, useState } from 'react'
import 'react-datepicker/dist/react-datepicker.css'
import { DateSelection } from './types'
import { formatUiDate } from 'utils'
import ReactDatePicker from 'react-datepicker'
import styles from './datePickerWtn.module.scss'
import MonthPickerHeader from './MonthPickerHeader'

const MonthPicker = ({
  displayDate,
  onChange,
  minDate,
  maxDate,
}: {
  displayDate: Date
  onChange: (date: Date) => void
  minDate: DateSelection
  maxDate: DateSelection
}) => {
  const [startDate, setStartDate] = useState(displayDate)
  const [isOpen, setIsOpen] = useState(false)

  const handleChange = useCallback(
    e => {
      onChange(e)
      setIsOpen(prev => !prev)
      setStartDate(e)
    },
    [onChange]
  )

  const handleClick = useCallback(e => {
    e.preventDefault()
    setIsOpen(prev => !prev)
  }, [])

  const handleCancel = useCallback(e => {
    setIsOpen(false)
  }, [])

  return (
    <div className={styles.monthYearBtnContainer}>
      <button className={styles.monthYearBtn} onClick={handleClick}>
        {formatUiDate(displayDate.toISOString(), { formatTo: 'MMM YYYY' })}
      </button>
      {isOpen && (
        <div className={styles.monthYearPickerWrapper}>
          <ReactDatePicker
            className={styles.monthYearPicker}
            minDate={minDate}
            maxDate={maxDate}
            renderCustomHeader={MonthPickerHeader}
            selected={startDate}
            onChange={handleChange}
            onClickOutside={handleCancel}
            showMonthYearPicker
            inline
            showPopperArrow={false}
          />
        </div>
      )}
    </div>
  )
}

export default MonthPicker
